"use strict";

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var MobileHeader_1 = require("./MobileHeader");

var AppHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AppHeader, _React$Component);

  function AppHeader() {
    var _this;

    _classCallCheck(this, AppHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppHeader).apply(this, arguments));
    _this.state = {
      width: window.innerWidth
    };

    _this.recordWindowWidth = function () {
      _this.setState({
        width: window.innerWidth
      });
    };

    return _this;
  }

  _createClass(AppHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.recordWindowWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.recordWindowWidth);
    }
  }, {
    key: "render",
    value: function render() {
      var mobileHeaderProps = this.props;
      return React.createElement(MobileHeader_1.MobileHeader, Object.assign({}, mobileHeaderProps));
    }
  }]);

  return AppHeader;
}(React.Component);

exports.AppHeader = AppHeader;